import { UPCOMING } from "@/lib/site-data";
import FadeIn from "@/components/FadeIn";

export default function Upcoming() {
  return (
    <section
      id="upcoming"
      data-testid="upcoming-section"
      className="relative py-24 sm:py-32 bg-[#0F3D3E] text-[#F4EDE4] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06]">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, #7A8F6B 0, transparent 35%), radial-gradient(circle at 80% 70%, #2C7A7B 0, transparent 40%)",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <FadeIn>
              <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#7A8F6B]">
                <span className="h-px w-8 bg-[#7A8F6B]" />
                Coming Soon
              </div>
            </FadeIn>
            <FadeIn delay={100}>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                Upcoming{" "}
                <span className="italic text-[#F4EDE4]/90">destinations</span>
              </h2>
            </FadeIn>
          </div>
          <FadeIn delay={200}>
            <p className="max-w-md text-[#F4EDE4]/75 leading-relaxed">
              Launching soon with trusted global and local DMC partnerships for
              premium travel experiences.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {UPCOMING.map((d, i) => (
            <FadeIn
              key={d.name}
              delay={i * 120}
              data-testid={`upcoming-card-${d.name.toLowerCase()}`}
              className="group relative rounded-3xl overflow-hidden aspect-[4/5] border border-white/10"
            >
              <img
                src={d.image}
                alt={d.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F3D3E]/90 via-[#0F3D3E]/30 to-transparent" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <div className="text-[11px] uppercase tracking-[0.25em] text-[#7A8F6B]">
                  Launching soon
                </div>
                <div className="mt-2 font-display text-4xl sm:text-5xl leading-none">
                  {d.name}
                </div>
                <div className="mt-4 inline-flex items-center gap-2 text-sm text-[#F4EDE4]/80 w-fit">
                  <span className="size-1.5 rounded-full bg-[#7A8F6B]" />
                  Join the waitlist
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
